export enum RATING_STYLE {
  STAR = 'star',
  SCORE = 'score'
}

export enum BUTTON_TYPE {
  regular = 'regular',
  icon = 'icon-only'
}
